/** 
*@author: Sirisha.M
*@Description : 
**/
/* eslint-disable no-unused-vars */
import React, { Fragment, useState, useEffect, useRef } from 'react';
import { constant } from '../Utils/constants';
import { Form, message, Upload, Select } from 'antd';
import localStorage from '../../../utils/localStorage';
import { IPAddress, UPLOAD } from '../../../commons/api';
import { DownloadOutlined, UploadOutlined } from '@ant-design/icons';
import themeSettings from '../../../commons/styles/themeSettings.json';
import { getDeviceFileDownloadName, getDeviceTypeList } from '../APICalls';

const UploadDevices = (props) => {
  const [formObject, setFormObject] = useState({});
  const [deviceTypeList, setDeviceTypeList] = useState([]);
  const [fileDownloadName, setFileDownloadName] = useState('');
  const hRef = useRef();

  const { ShowForm, selectedRow, translationCache, parent, Module, GetHierarchyLevelsUpdated } = props;

  useEffect(() => {
    setData(ShowForm);
  }, [ShowForm, selectedRow]);

  const setData = async (ShowForm) => {
    if (ShowForm === 'UPLOAD_DEVICES') {
      if (selectedRow && selectedRow.Type === 'DeviceType') {
        getFileDownloadName(selectedRow.Code);
        setFormObject({
          DeviceTypes: selectedRow.Code,
        });
      } else {
        GetDeviceType(Module);
      }
    }
  };

  const GetDeviceType = async (Module) => {
    let deviceTypeList = await getDeviceTypeList(Module);
    setDeviceTypeList(deviceTypeList);
  };

  const translation = (keyword) => {
    return translationCache && translationCache[keyword] ? translationCache[keyword] : keyword;
  };

  const getFileDownloadName = async (DeviceTypes) => {
    let AssetAlias = selectedRow?.Type === 'Asset' ? selectedRow.Code : parent.Code;
    let fileDownloadName = await getDeviceFileDownloadName(DeviceTypes, AssetAlias);
    setFileDownloadName(fileDownloadName?.file || '');
  };

  const onFieldChange = (fieldValue, fieldName) => {
    setFormObject((prevFormObject) => ({
      ...prevFormObject,
      [fieldName]: fieldValue,
    }));
    getFileDownloadName(fieldValue);
  };

  const siteId = localStorage.get('currentSite');
  const token = localStorage.get('accessToken');
  const Authorization = 'Bearer ' + token;

  return (
    <Fragment>
      <div
        style={{
          color: 'white',
          
          display: 'flex',
          justifyContent: 'center',
          marginBottom: '24px',
        }}
      >
        {`System bulk upload for ${selectedRow.Name}`}
      </div>

      <Form
        name="Item"
        ref={hRef}
        theme={themeSettings}
        layout="horizontal"
        labelCol={{ flex: '130px', marginTop: '20px' }}
        labelAlign="right"
        labelWrap
      >
        <div style={{ display: 'flex', flexWrap: 'wrap' }}>
          {selectedRow.Type === 'DeviceType' ? null : (
            <Form.Item
              name="DeviceTypes"
              rules={[
                {
                  required: true,
                  message: 'Please select DeviceType!',
                },
              ]}
              label={translation(constant.DeviceTypes)}
              style={{ width: '50%' }}
            >
              <Select
                value={formObject?.DeviceTypes}
                onChange={(e) => onFieldChange(e, 'DeviceTypes')}
              >
                {deviceTypeList &&
                  Array.isArray(deviceTypeList) &&
                  deviceTypeList.map((devicetype, index) => (
                    <Select.Option key={index} value={devicetype.AliasCode}>
                      {devicetype.Name}
                    </Select.Option>
                  ))}
              </Select>
            </Form.Item>
          )}

          {formObject?.DeviceTypes ? (
            <>
              <Form.Item
                name="Download Devices"
                style={{ width: '50%' }}
                label={translation(constant.DownloadDevices)}
              >
                <a href={`${IPAddress.LOCAL}${fileDownloadName}`}>
                  <DownloadOutlined style={{ color: 'white', marginRight: '1px' }} />
                  <span style={{ color: 'white' }}>Download</span>
                </a>
              </Form.Item>

              <Form.Item
                name="Upload Devices"
                style={{ width: '50%' }}
                label={translation(constant.UploadDevices)}
              >
                <Upload
                  multiple={false}
                  style={{ marginRight: '10px', color: 'white' }}
                  onChange={(info) => {
                    if (info.file.status === 'done') {
                      message.success(info.file.response.message);
                      GetHierarchyLevelsUpdated();
                      getFileDownloadName(formObject.DeviceTypes);
                    } else if (info.file.status === 'error') {
                      message.error(info.file.response.message);
                    }
                  }}
                  action={`${UPLOAD.CLIENT_Upload_Device}?SiteId=${siteId}&AssetCode=${selectedRow?.Type === 'Asset' ? selectedRow.Code : parent.Code
                    }&DeviceType=${selectedRow?.Type === 'Asset' ? formObject.DeviceTypes : selectedRow.Code
                    }&EquipmentType=Parent&ParentEquipment=null`}
                  headers={{
                    Authorization: Authorization,
                  }}
                  showUploadList={false}
                >
                  <UploadOutlined style={{ color: 'white', marginRight: '1px' }} />
                  <span style={{ color: 'white', marginRight: '10px' }}> Upload </span>
                </Upload>
              </Form.Item>
            </>
          ) : null}
        </div>
      </Form>
    </Fragment>
  );
};

export default UploadDevices;
